import { StatusFile } from './status-file.enum';

export class FileDto {
  id?: string;
  name: string;
  storageFile: string;
  storageBucket: string;
  mimeType?: string;
  size: number;
  approvedDisapprovedDate?: Date;
  approvedDisapprovedUserId?: string;
  requestedDeleteDate?: Date;
  deletedDate?: Date;
  userDeleteId?: string;
  status: StatusFile;
  parentId: string;
  createdAt?: Date;
  userCreationId?: string;
  updatedAt?: Date;
  userUpdateId?: string;
  page: number;
  /**
   * URL do sistema ADMIN em que o documento era exibido.
   */
  url_admin?: string;
}

export const ARQUIVO_TIPO_PDF = 'application/pdf';

export interface FileDownloadUrl {
  url: string;
}
